import { signalSetFn } from "@angular/core/primitives/signals";
import { FileMedia, IFileMedia } from "./file-media.model";
import { Gate, IGate } from "./gate.model";
import { HouseFlat, IHouseFlat } from "./house-flat.model";
import { IParcelService, ParcelService } from "./parcel-service.model";
import { IStreetBuilding, StreetBuilding } from "./street-building.model";

export interface IPackage {
  packageId: string;
  neighborhoodId: string;
  streetBuildingId: string;
  houseFlatId: string;
  parcelServiceId: string;
  gateId: string;
  otherName: string;
  packagesNumber: number;
  token: string;
  deliverySignatureId?: string;
  signatureRecipientId?: string;
  idFileId?: string;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  pickedUpAt?: string;
  createdAt: string;
  updatedAt: string;
  streetBuilding?: IStreetBuilding;
  houseFlat?: IHouseFlat;
  parcelService?: IParcelService;
  gate?: IGate;
  deliverySignature?: IFileMedia;
  signatureRecipient?: IFileMedia;
  idFile?: IFileMedia;
  files?: IFileMedia[];
}

export class Package {

  packageId: string;
  neighborhoodId: string;
  streetBuildingId: string;
  houseFlatId: string;
  parcelServiceId: string;
  gateId: string;
  otherName: string;
  packagesNumber: number;
  token: string;
  deliverySignatureId?: string;
  signatureRecipientId?: string;
  idFileId?: string;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  pickedUpAt?: string;
  createdAt: string;
  updatedAt: string;
  streetBuilding?: StreetBuilding;
  houseFlat?: HouseFlat;
  parcelService?: ParcelService;
  gate?: Gate;
  deliverySignature?: FileMedia;
  signatureRecipient?: FileMedia;
  idFile?: FileMedia;
  files: FileMedia[];

  constructor(
    data: IPackage
  ) {
    this.packageId = data.packageId;
    this.neighborhoodId = data.neighborhoodId;
    this.streetBuildingId = data.streetBuildingId;
    this.houseFlatId = data.houseFlatId;
    this.parcelServiceId = data.parcelServiceId;
    this.gateId = data.gateId;
    this.otherName = data.otherName;
    this.packagesNumber = data.packagesNumber;
    this.token = data.token;
    this.deliverySignatureId = data.deliverySignatureId;
    this.signatureRecipientId = data.signatureRecipientId;
    this.idFileId = data.idFileId;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.pickedUpAt = data.pickedUpAt;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.streetBuilding = data.streetBuilding
      ? new StreetBuilding(data.streetBuilding)
      : undefined;
    this.houseFlat = data.houseFlat
      ? new HouseFlat(data.houseFlat)
      : undefined;
    this.parcelService = data.parcelService
      ? new ParcelService(data.parcelService)
      : undefined;
    this.gate = data.gate
      ? new Gate(data.gate)
      : undefined;
    this.deliverySignature = data.deliverySignature
      ? new FileMedia(data.deliverySignature)
      : undefined;
    this.signatureRecipient = data.signatureRecipient
      ? new FileMedia(data.signatureRecipient)
      : undefined;
    this.idFile = data.idFile
      ? new FileMedia(data.idFile)
      : undefined;
    this.files = data.files
      ? data.files.map(file => new FileMedia(file))
      : [];
  }

  get statusLabel(): string {

    let status = '';

    if(this.status) {
      status = 'Entregado';
    } else {
      status = 'Pendiente';
    }

    return status;

  }

}
